import './index.sass';
import './courses-item/index.sass';
import './lesson-item/index.sass';
import axios from "axios";
import { loadNew } from '~/blocks/grid';

export default () => {
  const $root = $('.challenge');
  const $btn = $('.js-load-challenge');

  $btn.on('click', function (e) {
    e.preventDefault();
    const $el = $(this);
    initAjax($el);
  });

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.js-grid-container').append('<div class="list-loader"></div>');
    axios.get($el.data('url'), {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      const resp = response;
      const $items = $(resp.data.items);
      const url = resp.data.url;
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $items.addClass('grid-hidden');
      $root.find('.js-grid-container').append($items);
      loadNew($items);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.challenge__pagination').html(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }
}
